import { JwtHelperService } from '@alfresco/adf-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WkJwtHelperService {
  static readonly USER_ACCESS_TOKEN = JwtHelperService.USER_ACCESS_TOKEN;
  static readonly USER_PREFERRED_USERNAME =
    JwtHelperService.USER_PREFERRED_USERNAME;

  constructor(private readonly jwtHelperService: JwtHelperService) {}

  getValueFromToken(accessToken: string, key: string) {
    return this.jwtHelperService.getValueFromToken(accessToken, key);
  }
}
